import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Flex from "../../../components/Flex";
import {
  CurrentUser,
  setCurrentUser,
} from "../../../hooks/local-storage/use-current-user";
import { useGetPatientProfile } from "../../../queries/use-get-patient-profile";
import PatientNavBar from "./navbar/PatientNavBar";
import { getStoredRealm } from "@/utils/auth-storage";

const PatientPortalLayout = () => {
  const { data: patient } = useGetPatientProfile(getStoredRealm());

  useEffect(() => {
    if (patient?.data) setCurrentUser(patient.data as CurrentUser);
  }, [patient]);

  return (
    <Flex flexDirection={"column"} height={"100svh"}>
      {/* patient nav bar */}
      <PatientNavBar />

      <Flex height={"100%"} width={"100%"}>
        {/* patient side bar */}
        {/* <OutlineCard
          sx={{
            width: "256px",
            padding: 0,
            height: "100%",
          }}
        >
          <PatientPortalSideBar />
        </OutlineCard> */}

        {/* current section screen */}
        <Outlet
          context={{ patientId: (patient?.data as { uuid: string })?.uuid }}
        />
      </Flex>
    </Flex>
  );
};

export default PatientPortalLayout;
